// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___1XZjh","reducedFinishScreenImage":"styles-module__reducedFinishScreenImage___27XLR","finalScreenImage":"styles-module__finalScreenImage___1zN67"};